<template>
  <v-sheet
    v-ripple
    v-if="hasStudentPermission"
    @click="viewRecentStudentSubmissions"
    rounded
    class="pa-3 card ma-2 ma-md-5 text-center"
    :elevation="4"
  >
    <div class="snapbox">
      <div style="font-weight: bold; font-size: 14">
        Recent Student Submissions
      </div>
      {{ recentStudentSubmissionCount }}
    </div>

    <div class="text-caption text-center">Past 7 Days</div>

    <v-dialog scrollable v-model="showDialog" max-width="300px">
      <v-card class="pa-2">
        <v-card-title class="justify-space-between">
          <div>Recent Submissions</div>
          <div>
            <v-btn @click="showDialog = null" icon
              ><v-icon>mdi-close</v-icon></v-btn
            >
          </div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 300px">
          <keep-alive>
            <div class="my-2">
              Found {{ pagination.totalSize }}
              <span v-if="pagination.totalSize >= pagination.pageSize"
                >, showing {{ pagination.pageSize }} results</span
              >
              <span v-else>results</span>
            </div>
            <v-list shaped two-line>
              <v-list-item-group v-model="selectedSubmission" color="primary">
                <v-list-item
                  :to="{
                    name: 'studentRequirementSubmissionView',
                    params: { id: submission.id },
                  }"
                  v-for="submission in submissionList"
                  :key="submission.id"
                >
                  <v-list-item-avatar>
                    <div
                      class="pa-4 text-center outline rounded-circle"
                      v-text="
                        submission.requirements
                          ? submission.requirements.length
                          : 0
                      "
                    ></div>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title
                      >{{ submission.studentName }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      <div class="text-caption">
                        {{ submission.createdAt | formatDateYear }}
                        <span v-if="submission.submissionMethod"
                          >via {{ submission.submissionMethod }}</span
                        >
                      </div>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </keep-alive>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-center">
          <a
            class="nostyle mt-2"
            @click="$router.push({ name: 'studentRequirementSubmission' })"
          >
            View more...
          </a>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-sheet>
</template>

<script>
import { Role } from "@/router/_helper";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      showDialog: false,
      recentStudentSubmissionCount: 0,
      pagination: {
        current: 1,
        pageSize: 20,
        totalSize: 100,
      },
      options: {
        sortBy: [],
        sortDesc: [],
      },
      submissionList: [],
      activeOnly: true,
      selectedSubmission: null,
    };
  },
  computed: {
    ...mapGetters("auth", ["isLoggedIn", "currentUser", "userRoles"]),
    hasStudentPermission() {
      return (
        this.userRoles.includes(Role.ComplianceStudent) ||
        this.userRoles.includes(Role.Admin)
      );
    },
  },
  mounted() {
    this.getRecentStudentSubmissions();
  },
  methods: {
    ...mapActions("messages", [
      "addErrorMessage",
      "addMessage",
      "addSuccessMessage",
    ]),
    ...mapActions("studentRequirementSubmission", [
      "fetchStudentRequirementSubmissions",
    ]),

    getRecentStudentSubmissions() {
      const weekOld = moment().subtract(7, "days");
      const params = {
        page: 0,
        size: 10,
        sort: "id,desc",
        startDate: weekOld.format("YYYY-MM-DD"),
      };
      this.fetchStudentRequirementSubmissions(params)
        .then((response) => {
          if (response) {
            this.recentStudentSubmissionCount = response.totalElements;
            this.recentStudentSubmissions = response.content;
          }
        })
        .catch((error) => {
          this.addErrorMessage("Server response with error " + error);
        });
    },

    viewRecentStudentSubmissions() {
      if (this.recentStudentSubmissionCount > 0) {
        this.showDialog = true;
        this.getResources();
      }
    },
    getResources() {
      const startDate = moment().add(-7, "days").format("YYYY-MM-DD");

      //default to sorting by ID desc if not defined
      const sortBy =
        this.options["sortBy"] && this.options["sortBy"].length > 0
          ? this.options.sortBy[0]
          : "id";
      const sortDesc =
        this.options["sortDesc"] && this.options["sortDesc"].length > 0
          ? this.options.sortDesc[0]
          : true;

      const params = {
        page:
          this.pagination.pageIndex && this.pagination.pageIndex > 0
            ? this.pagination.pageIndex - 1
            : 0,
        size: this.pagination.pageSize,
        sort: `${sortBy}${sortDesc ? ",desc" : ""}`,
        startDate,
      };

      this.fetchStudentRequirementSubmissions(params)
        .then((response) => {
          if (response) {
            this.pagination.totalSize = response.totalElements;
            this.submissionList = response.content;
          }
        })
        .catch((error) => {
          this.addErrorMessage("Server response with error " + error);
        });
    },
    view(submission) {
      this.$router.push({
        name: "submissionView",
        params: { id: submission.id },
      });
    },
    ageGender(submission) {
      let info = "";
      if (submission.dob) {
        const ageYears = moment().diff(submission.dob, "years", false);
        const ageMonths = moment().diff(submission.dob, "months", false) % 12;
        info += `${ageYears}y${ageMonths}m`;
      }
      if (submission.gender) {
        if (info) {
          info += ` ${submission.gender} `;
        } else {
          info = submission.gender;
        }
      }
      return info;
    },
  },
};
</script>
<style scoped>
.outline {
  background-color: #e3f2fd;
}

.snapbox{
  display: block;
}

@media (max-width: 1400px) {
  .snapbox {
    font-size: 12px;
  }
}
</style>
